import { defineComponent as _defineComponent } from 'vue'
import { loadStripe } from '@stripe/stripe-js'
import { useEventQuery } from '@/enitites/event/api/queries'
import { useImage } from '@/shared/composables/image'
import { computed, onMounted, ref } from 'vue'
// @ts-expect-error Not a ts file
import store from '@/store'
import {
  useCashTierChangeMutation,
  useChangeTicketTierMutation,
  useStripeTierChangeMutation,
} from '@/features/tickets/api/queries'
import BKInput from '@/components/AppShared/BKInput.vue'
import useValidationRules from '@/shared/composables/validation'
import { centsToDollars } from '@/services/currency'
import { ICashUpgradeRequest } from '@/features/tickets/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeTicketsInterface',
  props: {
    eventId: null,
    ticketId: null,
    newTierId: null,
    isAdmin: { type: Boolean }
  },
  emits: ["close", "tier-changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'tier-changed'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventId: number
  ticketId: number
  newTierId: number
  isAdmin?: boolean
};





const { getImageById } = useImage()
const rules = useValidationRules()
const getUserDB = computed(() => store.getters.getUserDB)
const { data: event, isLoading: isLoadingEvent, isError: isEventError } = useEventQuery(props.eventId)
const {
  mutate: postChange,
  isPending: isPostingChange,
  error: errorPostingChange,
  data: tierChangeQuote,
} = useChangeTicketTierMutation()
const {
  mutate: postStripeTierChange,
  isPending: isPostingCheckout,
  error: errorPostingCheckout,
} = useStripeTierChangeMutation(props.eventId)
const {
  mutate: postCashTierChange,
  isPending: isPostingCashPayment,
  error: errorPostingCashPayment,
} = useCashTierChangeMutation(props.eventId)

const isFormValid = ref(true)
const stripeError = ref<string | null>(null)
const isPaymentInitialized = ref(false)
const contactName = ref(getUserDB.value?.dancerName || '')
const contactEmail = ref(getUserDB.value?.aEmail || getUserDB.value?.parentEmail || '')

const initPaymentElement = async (clientSecret: string) => {
  isPaymentInitialized.value = true

  let stripe
  try {
    stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
  } catch (error) {
    stripeError.value = (error as Error)?.message || 'An error occurred while loading payment gateway.'
    isPaymentInitialized.value = false
    return
  }

  if (!stripe) {
    stripeError.value = 'Failed to load payment gateway.'
    return
  }

  let checkout
  try {
    stripeError.value = null
    checkout = await stripe.initEmbeddedCheckout({ clientSecret })
  } catch (error) {
    stripeError.value = (error as Error)?.message || 'An error occurred while initializing payment.'
    isPaymentInitialized.value = false
    return
  }

  if (!checkout) {
    stripeError.value = 'Failed to initialize payment elements.'
    return
  }

  checkout.mount('#payment-element')
}

const handlePurchase = () => {
  if (
    !isFormValid.value ||
    isPostingChange.value ||
    !tierChangeQuote.value ||
    isPostingCheckout.value ||
    isPostingCashPayment.value
  )
    return

  if (props.isAdmin) {
    const tierChangeRequest: ICashUpgradeRequest = {
      newTierId: tierChangeQuote.value.newTierId,
      paymentOption: 'cash',
    }
    postCashTierChange(
      {
        ticketId: props.ticketId,
        data: tierChangeRequest,
      },
      {
        onSuccess: () => {
          emit('tier-changed')
        },
      }
    )
    return
  }

  postStripeTierChange(
    {
      ticketId: props.ticketId,
      data: {
        ...(tierChangeQuote.value || {}),
        contactName: contactName.value,
        contactEmail: contactEmail.value,
      },
    },
    {
      onSuccess: (response) => {
        if ('clientSecret' in response && response.clientSecret) {
          try {
            stripeError.value = null
            initPaymentElement(response.clientSecret)
          } catch (error) {
            stripeError.value = (error as Error)?.message || 'An error occurred while initializing payment.'
          }
        }
      },
    }
  )
}

onMounted(() => {
  if (props.newTierId && props.ticketId) {
    postChange({
      ticketId: props.ticketId,
      data: { newTierId: props.newTierId },
    })
  }
})

return { __sfc: true,props, emit, getImageById, rules, getUserDB, event, isLoadingEvent, isEventError, postChange, isPostingChange, errorPostingChange, tierChangeQuote, postStripeTierChange, isPostingCheckout, errorPostingCheckout, postCashTierChange, isPostingCashPayment, errorPostingCashPayment, isFormValid, stripeError, isPaymentInitialized, contactName, contactEmail, initPaymentElement, handlePurchase, BKInput, centsToDollars }
}

})